import { useEffect, useState } from "react";

import cropr, { BackboneModel } from "../utils/cropr";

// Type should be in key of cropr collections
type CollectionTypes =
  | "stock"
  | "farm_contacts"
  | "records"
  | "cropfields"
  | "plans"
  | "applications"
  | "revenueDefinitions";

const useCroprBackbone = <T extends BackboneModel = BackboneModel>(
  collectionName: CollectionTypes
): [any[], Backbone.Collection<T>] => {
  const collection = cropr[collectionName];
  const [attributes, setAttributes] = useState<any>(collection.toJSON());

  useEffect(() => {
    const handleChange = () => {
      setAttributes(collection.toJSON());
    };

    collection.on("all", handleChange);
    return () => {
      collection.off("all", handleChange);
    };
  }, [collection]);

  // @ts-ignore
  return [attributes, collection];
};

export default useCroprBackbone;

// const setData = (data: any) => {
//   const { id, ...rest } = data;
//   let model;
//   if (id) {
//     model = collection.get(id);
//   } else {
//     model = new collection.model();
//   }
//   // Lookup by id - heeft hij een ID, haal 'm uit de collectie
//   // save met dat object
//   model.saveAndAddNewTo(collection, data);
// };
